var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications"},_vm._l((_vm.notificationList),function(notification){return _c('div',{key:notification.id,staticClass:"notification"},[_c('notification',{attrs:{"notification":notification}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }